<template>
  <div class="app" id="app">
    <Header v-if="!hide_header"></Header>
    <router-view style="max-height: calc(100% - 50px);"/>
    <GoTop></GoTop>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      hide_header: false,
    };
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.hide_header = val.query.hide_header
      }
    }
  }
}
</script>

<style>
.app {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
}

.el-table .cell {
  font-size: 16px!important;
}

@media screen and (max-width: 768px) {
  .el-table .cell {
    font-size: 12px!important;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  .el-table .cell {
    font-size: 14px!important;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue